module.exports = __webpack_public_path__ + "img/icon-x-gray.c912799f.svg";